import { get } from 'lodash';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import type { ReducerPayload, UpdatePayload, WidgetContainer } from '@swf/core/types/Widget';
import { fetchProperties } from '@swf/core/utils/widgets';

type UpdateWidgetState = (
  keyOrReducer: string | UpdatePayload['reducer'],
  data?: ReducerPayload['data']
) => void;

const useUpdateWidgetState = ({ type, id, config }: WidgetContainer): UpdateWidgetState => {
  const dispatch = useDispatch<Dispatch>();

  return useCallback<UpdateWidgetState>(
    (keyOrReducer, data?) => {
      if (typeof keyOrReducer === 'string') {
        fetchProperties(type).then(({ serviceReducers }) => {
          const reducer = get(serviceReducers, keyOrReducer);
          dispatch.widgets.response({
            id,
            reducer,
            key: keyOrReducer,
            data,
            config,
            meta: {}
          });
        });
      } else {
        dispatch.widgets.update({ id, reducer: keyOrReducer });
      }
    },
    [config, dispatch.widgets, id, type]
  );
};

export default useUpdateWidgetState;
